import {convertCssAniDurationToMS} from "../utilities/helper-function";

class ExpandableText {
    constructor(element) {
        this.element = element;
        this.main = this.element.querySelector('.expandable-content__main');
        this.paragraph = this.main.querySelector('p');
        this.paragraphText = this.paragraph.innerText;
        this.paragraphLimit = this.main.dataset.charLimit;
        this.btnContainer = this.element.querySelector('.expandable-content__btns');
        this.readMoreBtn = this.element.querySelector('.expandable-content__btn-more');
        this.readLessBtn = this.element.querySelector('.expandable-content__btn-less');

        this.isResized = false;
        this.rootStyles = getComputedStyle(document.documentElement);
        this.aniFast= convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--fast').trim());

        window.addEventListener('load', () => {
            if(this.paragraphText.length > this.paragraphLimit) {
                this.limitedText = this.paragraphText.substring(0, this.paragraphLimit);
                this.limitContent(true);
                this.btnContainer.classList.add('expandable-content__btns--show');
            }
        })

        window.addEventListener('resize', () => {
            this.isResized = true;
            this.adjustHeightByResize();
        })

        this.readMoreBtn.addEventListener('click', () => this.expandContent());
        this.readLessBtn.addEventListener('click', () => this.limitContent());
    }

    adjustHeightByResize() {
        setTimeout(() => {
            this.main.removeAttribute('style');

            if(this.main.classList.contains("expandable-content__main--limited")) {
                this.limitedHeight = this.main.scrollHeight
            } else {
                this.limitedHeight = "auto";
                this.maxHeight = this.main.scrollHeight;
            }
            this.main.style.height = this.main.scrollHeight + "px";
        }, this.aniFast);
    }

    limitContent(isInitial) {
        this.main.classList.add('expandable-content__main--limited');

        if(isInitial || this.isResized) {
            this.isResized = false;
            this.maxHeight = this.main.scrollHeight;
            this.paragraph.innerText = this.limitedText;
            this.main.style.height = "auto";

            setTimeout(() => {
                this.limitedHeight = this.main.scrollHeight;
                this.main.style.height = this.limitedHeight + "px";
            }, this.aniFast);


        } else {
            this.paragraph.innerText = this.limitedText;
        }

        if(this.limitedHeight === "auto") {
            this.main.style.height = this.limitedHeight;
        } else {
            this.main.style.height = this.limitedHeight + "px";
        }
        this.readMoreBtn.classList.add('expandable-content__btn-more--show');
        this.readLessBtn.classList.remove('expandable-content__btn-less--show');
    }

    expandContent() {
        this.main.classList.remove('expandable-content__main--limited');
        this.paragraph.innerText = this.paragraphText;

        if(this.isResized) {
            this.main.style.height = "auto";
            setTimeout(() => {
                this.maxHeight = this.main.scrollHeight
                this.main.style.height = this.maxHeight + "px";
            }, this.aniFast);
            this.isResized = false;
        } else {
            this.main.style.height = this.maxHeight + "px";
        }

        this.readMoreBtn.classList.remove('expandable-content__btn-more--show');
        this.readLessBtn.classList.add('expandable-content__btn-less--show');
    }
}

export default ExpandableText;